import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RoomInformation } from '@rx-applications/clientsite/shared/utils';

import { RxButtonModule } from '@roomex/rx-components';
import { RoomMoreDetailsComponent } from './room-more-details/room-more-details.component';

@Component({
  selector: 'rx-applications-more-details',
  templateUrl: './more-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RxButtonModule, RoomMoreDetailsComponent],
  standalone: true,
})
export class MoreDetailsComponent {
  @Input() room: RoomInformation;

  constructor(public activeModal: NgbActiveModal) {}
}
